import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import styles from './Row.module.sass';
import { IEventTicketListItem } from '@types';
import Icon from 'components/Icon';
import Checkbox from 'components/Checkbox';
import { TicketRequestStatus } from '@core';
import { paths } from 'router/paths';

interface RowProps {
  item: IEventTicketListItem;
  onApprove: (id: IEventTicketListItem) => void;
  isSelected: boolean;
  onSelect: (checked: boolean) => void;
}

const Row = ({ item, onApprove, isSelected, onSelect }: RowProps) => {
  const navigate = useNavigate();
  const approveTicket = () => {
    const confirmed = window.confirm('ნამდვილად გსურთ დადასტურება?');
    if (!confirmed) {
      return;
    }
    onApprove(item);
  };

  const navigateToDetails = (id: string) => {
    navigate(paths.USER_DETAILS_PATH.replace(':id', id));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.checked);
  };

  return (
    <>
      <div className={cn(styles.row)}>
        <div className={styles.col}>
          <Checkbox
            className=""
            value={isSelected}
            onChange={handleCheckboxChange}
            classCheckboxTick=""
            content=""
            reverse={false}
          />
        </div>
        <div className={styles.col}>
          <div
            className={styles.item}
            onClick={() => {
              navigateToDetails(item.user.id);
            }}
          >
            <div className={styles.avatar}>
              <img
                src={item.user.profilePhoto !== '' ? item.user.profilePhoto : '/images/content/avatar-2.jpg'}
                alt="Profile Photo"
              />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>{`${item.user.firstName} ${item.user.lastName}`}</div>
              <div className={styles.city}>{item.user.phoneNumber}</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div>{item.quantity} </div>
        </div>

        <div className={styles.col}>
          <div>{item.updatedAt}</div>
        </div>

        <div className={styles.col}>
          <div>
            {item.status === TicketRequestStatus.Approved && (
              <div className={cn('status-green', styles.status)}>დადასტურებულია</div>
            )}

            {item.status === TicketRequestStatus.Delivered && (
              <div className={cn('status-blue', styles.status)}>გაცემული</div>
            )}
          </div>
        </div>

        <div className={styles.col}>
          {item.status === TicketRequestStatus.Approved && (
            <button
              onClick={approveTicket}
              className={cn('button', 'button-small', 'button-stroke-green', styles.button)}
            >
              <Icon name="check" size="24" />
            </button>
          )}

          {item.status === TicketRequestStatus.Delivered && item.qrCodeLinks && item.qrCodeLinks.length > 0 && (
            <div className={styles.qrLinks}>
              {item.qrCodeLinks.map((link, index) => (
                <a
                  key={link}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={link}
                  className={cn('button', 'button-small', 'button-stroke')}
                >
                  {item.qrCodeLinks!.length > 1 ? `QR ${index + 1}` : 'QR კოდი'}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Row;
